import { useToggle } from 'react-use';

import { Patient } from '@dreryk/egabinet-patient-frontend-api';
import { IdentityDocument } from '@dreryk/egabinet-patient-published-language-api';

import { EditIcon, Link, StyledFlex } from '@dreryk/react-components';

import { identityDocumentTranslationKeys } from '../../../../../../../../translations';

import { PassportIdentityDocumentEditModal } from './PassportIdentityDocumentEditModal';
import { PassportIdentityDocumentText } from './PassportIdentityDocumentText';

type PassportIdentityDocumentEditLinkProps = {
   readonly patientId: number;
   readonly identityDocument: IdentityDocument;
   readonly onIdentityDocumentUpdated: (patient: Patient) => Promise<void> | void;
};

export const PassportIdentityDocumentEditLink = (props: PassportIdentityDocumentEditLinkProps): JSX.Element => {
   const { onIdentityDocumentUpdated } = props;
   const [showModal, toggleShowModal] = useToggle(false);

   return (
      <>
         <StyledFlex direction={'row'} gap={'24px'} alignItems={'center'}>
            <PassportIdentityDocumentText identityDocument={props.identityDocument} />
            <Link
               testId={'passportIdentityDocumentEdit'}
               onClick={toggleShowModal}
               label={identityDocumentTranslationKeys.passport.edit.button.label}
               icon={<EditIcon />}
            />
         </StyledFlex>

         {showModal ? (
            <PassportIdentityDocumentEditModal
               patientId={props.patientId}
               identityDocument={props.identityDocument}
               onIdentityDocumentUpdated={onIdentityDocumentUpdated}
               onCancel={toggleShowModal}
               onSuccess={toggleShowModal}
            />
         ) : null}
      </>
   );
};
